export class Schedule {

    scheduleId: number;
    patientId: number; 
    companyId: number; 
    procedureId: number;
    insuranceId: number;
    hour: string;
    date: string; 
    obs: string;
}
